import { type MutableRefObject, type ReactNode, type RefObject } from 'react';
import { AnchoredPanel } from './AnchoredPanel';

interface AnchoredListboxProps {
  /** Element the panel is positioned against and width-matched to. */
  anchorRef: RefObject<HTMLElement | null>;
  /**
   * The panel element, for callers that close on outside click — the menu is
   * portalled out of the trigger's subtree, so it has to be asked directly.
   */
  panelRef?: MutableRefObject<HTMLDivElement | null>;
  open: boolean;
  id?: string;
  ariaLabel: string;
  children: ReactNode;
}

// The autosuggest dropdown: every "type a few letters, pick a medicine" field in
// the app renders its results through here.
//
// This is `AnchoredPanel` plus the listbox role — the portal and the placement
// live there, and are shared with the app's other dropdowns so there is exactly
// one implementation of "where does a floating panel go" to get right.
export function AnchoredListbox({
  anchorRef,
  panelRef,
  open,
  id,
  ariaLabel,
  children,
}: AnchoredListboxProps) {
  return (
    <AnchoredPanel anchorRef={anchorRef} panelRef={panelRef} open={open}>
      <ul id={id} role="listbox" aria-label={ariaLabel}>
        {children}
      </ul>
    </AnchoredPanel>
  );
}
